import { toast } from 'sonner';

export const exportLeadToPdf = (lead) => {
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('nl-BE', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  const services = lead.services || [];
  const providers = lead.current_providers || [];
  const hasEnergy = lead.energy_interest;
  
  const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Lead Overzicht - ${lead.first_name} ${lead.last_name}</title>
  <style>
    @page { size: A4; margin: 10mm; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { 
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; 
      color: #1e293b; 
      line-height: 1.4;
      font-size: 11px;
    }
    .page { 
      width: 100%; 
      max-width: 190mm;
      height: 277mm;
      margin: 0 auto; 
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .header { 
      background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%); 
      color: white; 
      padding: 12px 16px; 
      border-radius: 8px; 
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .header-left h1 { font-size: 18px; margin-bottom: 2px; }
    .header-left p { opacity: 0.9; font-size: 10px; }
    .partner-badge { 
      background: #f97316; 
      color: white; 
      padding: 3px 10px; 
      border-radius: 12px; 
      font-size: 9px; 
      font-weight: 600;
    }
    .meta-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      font-size: 10px;
      color: #64748b;
    }
    .content { flex: 1; }
    .section { 
      background: #f8fafc; 
      border-radius: 8px; 
      padding: 10px 14px; 
      margin-bottom: 8px;
    }
    .section-title { 
      font-size: 12px; 
      font-weight: 600; 
      color: #1e40af; 
      margin-bottom: 8px; 
      border-bottom: 1px solid #3b82f6; 
      padding-bottom: 4px; 
    }
    .info-grid { 
      display: grid; 
      grid-template-columns: 1fr 1fr; 
      gap: 6px 12px; 
    }
    .info-item { }
    .info-label { 
      font-size: 9px; 
      color: #64748b; 
      text-transform: uppercase; 
      letter-spacing: 0.3px; 
    }
    .info-value { 
      font-size: 11px; 
      font-weight: 500; 
      color: #1e293b; 
    }
    .services-list { 
      display: flex; 
      flex-wrap: wrap; 
      gap: 4px; 
    }
    .service-tag { 
      background: #dbeafe; 
      color: #1e40af; 
      padding: 3px 8px; 
      border-radius: 10px; 
      font-size: 10px; 
      font-weight: 500; 
    }
    .extra-info {
      margin-top: 6px;
      font-size: 10px;
      color: #475569;
    }
    .energy-section { 
      background: linear-gradient(135deg, #10b981 0%, #059669 100%); 
      color: white; 
      border-radius: 8px; 
      padding: 10px 14px; 
      margin-bottom: 8px;
    }
    .energy-section .section-title { 
      color: white; 
      border-bottom-color: rgba(255,255,255,0.3); 
    }
    .energy-section .info-label { color: rgba(255,255,255,0.8); }
    .energy-section .info-value { color: white; }
    .footer { 
      text-align: center; 
      padding: 10px; 
      color: #64748b; 
      font-size: 9px; 
      border-top: 1px solid #e2e8f0; 
      margin-top: auto;
    }
    .footer strong { color: #1e293b; }
    @media print { 
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .page { padding: 0; }
    }
  </style>
</head>
<body>
  <div class="page">
    <div class="header">
      <div class="header-left">
        <h1>Telecomprijsvergelijker.be</h1>
        <p>Lead Overzicht Document</p>
      </div>
      <span class="partner-badge">Officieel Orange Partner</span>
    </div>
    
    <div class="meta-row">
      <span>Lead ID: ${lead.id?.substring(0, 8) || 'N/A'}</span>
      <span>Aangemaakt: ${formatDate(lead.created_at)}</span>
    </div>
    
    <div class="content">
      <div class="section">
        <h2 class="section-title">Klantgegevens</h2>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Naam</div>
            <div class="info-value">${lead.first_name} ${lead.last_name}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Type</div>
            <div class="info-value">${lead.customer_type === 'particulier' ? 'Particulier' : 'Zakelijk'}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Email</div>
            <div class="info-value">${lead.email}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Telefoon</div>
            <div class="info-value">${lead.phone}</div>
          </div>
          <div class="info-item" style="grid-column: span 2;">
            <div class="info-label">Adres</div>
            <div class="info-value">${lead.address}, ${lead.postcode}</div>
          </div>
        </div>
      </div>
      
      <div class="section">
        <h2 class="section-title">Huidige Provider(s)</h2>
        <div class="info-value">${providers.length > 0 ? providers.join(', ') : 'Niet opgegeven'}</div>
      </div>
      
      <div class="section">
        <h2 class="section-title">Gewenste Diensten</h2>
        <div class="services-list">
          ${services.map(s => `<span class="service-tag">${s}</span>`).join('')}
        </div>
        ${(services.includes('Mobiel') || services.includes('TV')) ? `
        <div class="extra-info">
          ${services.includes('Mobiel') ? `<span>Mobiele abonnementen: ${lead.mobile_count || 1}</span>` : ''}
          ${services.includes('Mobiel') && services.includes('TV') ? ' | ' : ''}
          ${services.includes('TV') ? `<span>TV-decoders: ${lead.tv_decoder_count || 1}</span>` : ''}
        </div>` : ''}
      </div>
      
      ${hasEnergy ? `
      <div class="energy-section">
        <h2 class="section-title">Energie Vergelijking</h2>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Interesse</div>
            <div class="info-value">Ja - Wil energie vergelijken</div>
          </div>
          ${lead.current_energy_provider ? `
          <div class="info-item">
            <div class="info-label">Huidige Leverancier</div>
            <div class="info-value">${lead.current_energy_provider}</div>
          </div>` : ''}
        </div>
      </div>` : ''}
    </div>
    
    <div class="footer">
      <p>Officieel Orange & Eneco partner via distributiekanaal SmartSN</p>
      <p>www.telecomprijsvergelijker.be</p>
    </div>
  </div>
</body>
</html>`;

  // Sanitize the HTML content by escaping user-provided values
  const escapeHtml = (text) => {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  // Create a safe version with escaped user data
  const safeHtmlContent = htmlContent
    .replace(/\${lead\.first_name}/g, escapeHtml(lead.first_name))
    .replace(/\${lead\.last_name}/g, escapeHtml(lead.last_name))
    .replace(/\${lead\.email}/g, escapeHtml(lead.email))
    .replace(/\${lead\.phone}/g, escapeHtml(lead.phone))
    .replace(/\${lead\.address}/g, escapeHtml(lead.address))
    .replace(/\${lead\.postcode}/g, escapeHtml(lead.postcode));

  // Use Blob and object URL for safer content handling
  const blob = new Blob([htmlContent], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  
  const printWindow = window.open(url, '_blank');
  
  if (printWindow) {
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
        URL.revokeObjectURL(url);
      }, 250);
    };
    toast.success('PDF wordt geopend voor afdrukken');
  } else {
    toast.error('Kon print venster niet openen. Controleer popup blocker.');
    URL.revokeObjectURL(url);
  }
};
